import { Link, useLocation } from 'react-router-dom';

const TermFaqCategory = () => {
  const location = useLocation();
  
  const categories = [
    { key: 'packing', label: '梱包・発送について', path: '/terms/faq_packing_shipping' },
    { key: 'transaction', label: '取引・購入・出品について', path: '/terms/faq_trade_purchase_sell' },
    { key: 'payment', label: '振込・支払いについて', path: '/terms/faq_transfer_payment' },
    { key: 'compensation', label: '補償・返品について', path: '/terms/faq_compensation_return_reassessment' },
    { key: 'account', label: '会員情報・ログインについて', path: '/terms/faq_membership_login' },
    { key: 'trouble', label: 'トラブル・利用制限について', path: '/terms/faq_troubleshooting_restrictions' },
  ];

  return (
    <div className="w-full bg-white flex flex-col justify-start items-start gap-5">
      <div className="w-full h-9 px-[5px] inline-flex justify-start items-center gap-2.5">
        <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
        <div className="justify-center text-black text-2xl font-bold leading-9">カテゴリ</div>
      </div>
      <div className="w-full grid grid-cols-3 gap-2.5">
        {categories.map(({ key, label, path }) => {
          const isCurrentPage = location.pathname === path;
          
          if (isCurrentPage) {
            return (
              <div
                key={key}
                className="px-1 py-5 bg-[#e4e4e4] rounded-[10px] flex justify-center items-center"
              >
                <div className="text-center text-xl font-bold leading-[30px] text-[#aaaaaa]">
                  {label}
                </div>
              </div>
            );
          }
          
          return (
            <Link
              key={key}
              to={`${path}${location.search}`}
              className="px-1 py-5 bg-[#fbe0c9] rounded-[10px] flex justify-center items-center transition-colors hover:bg-[#f5d1b3]"
            >
              <div className="text-center text-xl font-bold leading-[30px] text-black">
                {label}
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default TermFaqCategory;